
import React, { useState, useEffect } from 'react';

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

const CountdownTimer = () => {
  const targetDate = new Date('2025-05-17T13:00:00');
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = +targetDate - +new Date();
      let newTimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

      if (difference > 0) {
        newTimeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      }

      return newTimeLeft;
    };

    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex flex-col items-center">
      <h3 className="text-xl md:text-2xl font-bold mb-4 text-floresta-acaiDark">
        Inauguração 17 de maio às 13h
      </h3>
      <div className="flex space-x-2 md:space-x-4">
        <TimeUnit value={timeLeft.days} label="dias" />
        <TimeUnit value={timeLeft.hours} label="horas" />
        <TimeUnit value={timeLeft.minutes} label="min" />
        <TimeUnit value={timeLeft.seconds} label="seg" />
      </div>
    </div>
  );
};

const TimeUnit = ({ value, label }: { value: number; label: string }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="bg-white shadow-lg rounded-lg p-2 md:p-3 w-14 md:w-20 h-14 md:h-20 flex items-center justify-center overflow-hidden relative">
        <span className="drop-shadow-md text-xl md:text-3xl font-bold text-floresta-acai">
          {value < 10 ? `0${value}` : value}
        </span>
        <div className="absolute -bottom-2 left-0 w-full h-3 bg-gradient-to-r from-floresta-acai to-floresta-acaiDark opacity-20 rounded-b-lg"></div>
      </div>
      <span className="text-xs md:text-sm mt-1 font-medium text-floresta-acaiDark">{label}</span>
    </div>
  );
};

export default CountdownTimer;
